<template>
    <div>
        <div class="vertical-center">
            <div class="col-lg-offset-12 col-lg-12 col-md-offset-12 col-md-12 col-sm-12 col-xs-12">
                <div class="panel panel-default country-select-panel text-center">
                    <div class="panel-heading">
                        <h3>Survey</h3>
                    </div>
                    <div class="panel-body">
                        <login-form></login-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import LoginForm from '../ui/LoginForm'

    export default {
        name: 'login',
        data() {
            return {
                logo: false
            }
        },
        mounted() {
            this.logo = this.$store.getters.getLogoPath;
        },
        methods: {

        },
        components: {LoginForm}
    }
</script>

<style scoped>

    body {
        color: white;
    }

    .container {
        height: 200px;
        position: relative;
        border: 3px solid green;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .panel {
        border: 1px solid black;
        background: #fffdfd;
    }

    .panel-heading {
        border-radius: 0;
    }
</style>
